import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  HotelsAvailabilityActions,
  HotelsAvailabilitySelectors,
  useFilterDialog as useCoreFilterDialog,
} from "@b2bportal/core-hotels";
import { HotelSortOptionEnum } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelsAvailabilityFilters } from "@tenant/hotels";

export const useFilterDialog = () => {
  const {
    context: coreContext,
    handlers: coreHandlers,
    text,
  } = useCoreFilterDialog();
  const { context: filterContext } = useHotelsAvailabilityFilters();
  const dispatch = useDispatch();

  const { t } = useI18nContext();

  const selectedSort = useSelector(HotelsAvailabilitySelectors.getSort);

  const [sortOption, setSortOption] = useState(selectedSort);

  const filtersChanged = useMemo(
    () => coreContext.filtersChanged || sortOption !== selectedSort,
    [coreContext.filtersChanged, sortOption, selectedSort]
  );

  const updateValuesToMatchState = useCallback(() => {
    coreHandlers.updateValuesToMatchState();
    setSortOption(selectedSort);
  }, [coreHandlers, selectedSort]);

  const resetAllFilters = useCallback(() => {
    coreHandlers.resetAllFilters();
    dispatch(
      HotelsAvailabilityActions.setSort(HotelSortOptionEnum.Recommended)
    );
  }, [dispatch, coreHandlers]);

  const applyFilter = useCallback(() => {
    coreHandlers.applyFilter();
    dispatch(HotelsAvailabilityActions.setSort(sortOption));
  }, [dispatch, coreHandlers, sortOption]);

  return {
    text: {
      ...text,
      sortBy: {
        title: t("sortBy"),
      },
    },
    context: {
      ...coreContext,
      totalFilterCount: filterContext.totalFilterCount,
      filtersChanged,
      sortOption,
    },
    handlers: {
      ...coreHandlers,
      updateValuesToMatchState,
      resetAllFilters,
      applyFilter,
      onSortChange: setSortOption,
    },
  };
};
